export const RECITAL_DETAIL_TAB = {
  SHOWS: 'shows',
  CONFLICTS: 'conflicts',
  SIZING: 'sizing',
  VOLUNTEERS: 'volunteers',
  CHECK_IN: 'check-in',
  STATS: 'stats',
  REPORTS: 'reports',
} as const;

export type RecitalDetailTab =
  (typeof RECITAL_DETAIL_TAB)[keyof typeof RECITAL_DETAIL_TAB];

const RECITAL_DETAIL_TAB_SET = new Set<string>(
  Object.values(RECITAL_DETAIL_TAB),
);

export function isRecitalDetailTab(
  value: string | undefined,
): value is RecitalDetailTab {
  return value !== undefined && RECITAL_DETAIL_TAB_SET.has(value);
}
